// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

var Types = {};

var fragmentConverter = {"__root":{"draftProperty_availableFrom":{"b":""}}};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

function localDraftPropertyType_decode($$enum) {
  if ($$enum === "FOR_SALE" || $$enum === "RENTAL") {
    return $$enum;
  }
  
}

function localDraftPropertyType_fromString(str) {
  return localDraftPropertyType_decode(str);
}

var Utils = {
  localDraftPropertyType_decode: localDraftPropertyType_decode,
  localDraftPropertyType_fromString: localDraftPropertyType_fromString
};

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeAvailableFrom_draft",
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LocalDraftProperty",
          "kind": "LinkedField",
          "name": "draftProperty",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "propertyType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "availableFrom",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timeZone",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "LocalDraft",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
